import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/layout/AppSidebar";
import { EntitySettingsGlobalModal } from "@/components/entities/EntitySettingsGlobalModal";

export function AppShellWithSidebar() {
  return (
    <div className="flex h-screen">
      <SidebarProvider>
        <AppSidebar />
        {/* Main content should be scrollable; keep min-h-0 for correct flexbox overflow behavior */}
        <SidebarInset className="flex-1 min-h-0 overflow-y-auto">
          <Outlet />
        </SidebarInset>
        <EntitySettingsGlobalModal />
      </SidebarProvider>
    </div>
  );
}